import styled from '@emotion/styled';

export const BlockingBackground = styled.div`
  width: 100vw;
  height: 100vh;
  position: absolute;
  background-color: var(--surface-main-modal-backdrop);
  top: 0;
  left: 0;
  /* In-page: it blocks the form beneath it, and every popup must still open over it. */
  z-index: var(--z-index-sticky);
`;
